import script from "./clear-cache.vue?vue&type=script&setup=true&lang=js"
export * from "./clear-cache.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__